import { CalendarEventVideoCallProvider } from '@griply/types';

const GENERIC_VIDEO_CALL_KEY = 'forms.event.fields.video-call.label';

const videoCallProviderNameKeys: Record<
  CalendarEventVideoCallProvider,
  string
> = {
  [CalendarEventVideoCallProvider.GoogleMeet]:
    'forms.event.fields.video-call.providers.google-meet',
  [CalendarEventVideoCallProvider.Teams]:
    'forms.event.fields.video-call.providers.teams',
  [CalendarEventVideoCallProvider.Skype]:
    'forms.event.fields.video-call.providers.skype',
  [CalendarEventVideoCallProvider.Other]:
    'forms.event.fields.video-call.providers.other',
};

// a provider a newer backend added must read as "a video call", never as a raw key
export const getVideoCallProviderNameKey = (
  provider?: CalendarEventVideoCallProvider | null,
): string =>
  (provider && videoCallProviderNameKeys[provider]) || GENERIC_VIDEO_CALL_KEY;
